module.exports = __webpack_public_path__ + "img/ContactUsIcon.8b19d8ea.png";